import GHLine from './GHLine';

export default class GHSegment {
  constructor (x0, y0, x1, y1) {
    this.x0 = x0;
    this.y0 = y0;
    this.x1 = x1;
    this.y1 = y1;
  }

  getLine () {
    let dx = this.x1 - this.x0;
    let dy = this.y1 - this.y0;
    let a = dy;
    let b = -dx;
    let c = dx * this.y0 - dy * this.x0;
    return new GHLine(a, b, c);
  }

  length () {
    let dx = (this.x0 - this.x1);
    let dy = (this.y0 - this.y1);
    return Math.sqrt(dx * dx + dy * dy);
  }

  getSegmentIntersectionPoint (segment) {
    let l0 = this.getLine();
    let l1 = segment.getLine();
    let ret = segment.intersectsByLine(l0) && this.intersectsByLine(l1);
    if (!ret) {
      return {
        result: ret
      };
    }

    let point = l0.getIntersectionPoint(l1);
    return {
      result: ret && (point !== null),
      point: point
    };
  }

  intersectsBySegment (segment) {
    let l0 = this.getLine();
    let l1 = segment.getLine();
    return segment.intersectsByLine(l0) && this.intersectsByLine(l1);
  }

  intersectsByLine (l) {
    let t1 = l.a * this.x0 + l.b * this.y0 + l.c;
    let t2 = l.a * this.x1 + l.b * this.y1 + l.c;
    return t1 * t2 <= 0;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/math/GHSegment.js